var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collection__cover-photo"},[_c('div',{staticClass:"collection__cover-photo__parallax-container"},[_c('v-img',{attrs:{"contain":"","max-height":_vm.mHeight,"src":_vm.imageData.url}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }